import BlogBanner from "@/components/Blog/BlogBanner";
import SEO from "@/components/SEO";
import Collection from "@sourceflow-uk/sourceflow-sdk/collection";
import localizePath from "@/functions/localizePath";

export default function BlogsPage({ locale = "en", blogs }) {
  return (
    <>
      <SEO
        path={localizePath("/newsroom/podcasts", locale)}
        title="Podcasts | Lawrence Harvey"
        description="We're up to date with all things tech"
      />
      <div className="bg-purple h-full sm:pt-[160px] blogs-page">
        <BlogBanner blogs={blogs} />
      </div>
    </>
  );
}

export async function getStaticProps() {
  const blogs = (await Collection("blogs"))
    .orderBy("created_at", "desc")
    .getItems();

  return { props: { blogs } };
}
